import { LatLngExpression } from 'leaflet';
import { useTheme } from '@mui/material/styles';
import { MapContainer, Circle, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

interface Props {
  coordinates: [number, number];
  zoom: number;
}

const Map = ({ coordinates, zoom }: Props): JSX.Element => {
  const theme = useTheme();
  const position: LatLngExpression = coordinates;
  const fillBlueOptions = {
    fillColor:
      theme.palette.mode === 'dark'
        ? theme.palette.primary.main
        : theme.palette.success.dark,
  };

  return (
    <MapContainer
      center={position}
      zoom={zoom}
      scrollWheelZoom={false}
      style={{ height: '400px', width: '100%' }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.amap.com/">高德地图</a>'
        url={`https://webrd04.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}&scl=1&ltype=11&lang=zh_cn&key=b8767ce45dbf7614c010ac199205352d`}
      />
      <Circle center={position} pathOptions={fillBlueOptions} radius={50} />
    </MapContainer>
  );
};

export default Map;
